import { styled } from "@mui/material";

const StyledInputLabel = styled("label")(
  ({ theme }) => `
  width: 100%;
  color: ${theme.palette.text.primary};
  font-weight: bold;
  margin: 3px 0;
`
);
export default StyledInputLabel;
